module.exports = __webpack_public_path__ + "static/img/medal1.df3be7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/medal1.png
// module id = ZqS/
// module chunks = 1